<template>
    <section>
        <div class="row justify-content-center">
            <div class="col col-lg-10 px-5">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb mt-5 mb-0 py-0">
                        <li class="breadcrumb-item h3 font-weight-bold active mb-0 text-uppercase" aria-current="page">
                            Forum
                        </li>
                    </ul>
                    <ul class="breadcrumb forum py-0">
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'index' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/index' }">
                                Forum
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/subject', params: {id: gradeSubject.gradeID} }">
                                {{ gradeSubject.grade.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium active" aria-current="page">
                            {{ gradeSubject.subject.name }}
                        </li>
                    </ul>
                </nav>
                <div class="row">
                    <div class="col">
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0 text-uppercase">
                                            {{ gradeSubject.subject.name }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body py-0">
                                <div class="row">
                                    <div class="col-12 col-sm-6 border-bottom py-3" v-for="category in categories">
                                        <router-link v-bind:to="{ name: 'forum/thread/index', params: {id: category.id} }" class="font-weight-bold h4 mb-1">{{ category.title }}</router-link>
                                        <div class="row text-muted">
                                            <div class="col" v-html="category.description"></div>
                                        </div>
                                        <div class="row text-muted">
                                            <div class="col-auto">
                                                Jumlah Thread: {{ category.totalThreads }}
                                            </div>
                                            <div class="col-auto">
                                                Solved Thread: {{ category.solvedThreads }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "ForumCategory",
        data() {
            return {
                gradeSubject: {grade: {}, subject: {}},
                categories: []
            };
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/grade-subject/' + this.$route.params.id),
                this.axios.get(process.env.API_URL + '/forum-subcategory', {params: {gradeSubjectID: this.$route.params.id}})
            ]).then(this.axios.spread(function (responseGradeSubject, responseCategory) {
                this.gradeSubject = responseGradeSubject.data.data;
                this.categories = responseCategory.data.data;

                document.title = 'Forum - ' + this.gradeSubject.grade.name + ' ' + this.gradeSubject.subject.name + ' | ' + process.env.APP_NAME;
            }.bind(this)));
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/forum/Category.vue